import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'vi-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent implements OnInit {
  private navigationId: number;

  constructor(private location: Location, private router: Router) {}

  ngOnInit(): void {
    this.navigationId = this.location.getState()?.['navigationId'];
  }

  clickHandler(): void {
    if (this.navigationId <= 1) {
      this.router.navigate(['/installations']);
    } else {
      this.location.back();
    }
  }
}
